export const actions = {
  create: 'create',
  edit: 'edit',
  fetch: 'fetch',
  delete: 'delete',
}
export const colors = ['danger', 'success', 'warning', 'success', 'primary', 'secondary']
